// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-e12b17d8]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.mobile-header[data-v-e12b17d8]{display:flex!important;height:44px;padding:0 16px}.mobile-header .left[data-v-e12b17d8]{cursor:pointer}.mobile-header .center[data-v-e12b17d8]{color:#1f1d29;font-size:18px;font-weight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
